





































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit, Watch } from "vue-property-decorator";
import { HeaderWidthItem } from "@/types";

interface StringKeyObject {
  [key: string]: object;
}

@Component({})
export default class NoOutputTable extends Vue {
  //表示項目
  @Prop() headers!: HeaderWidthItem[];

  //表示内容
  @Prop() items!: StringKeyObject[];

  //全て表示するの有無
  @Prop() isAllDisp!: boolean;

  //処理するボタンクリック
  @Emit()
  private edit(item: StringKeyObject) {
    return item.yearmonth;
  }

  //全ての期間を表示ボタンクリック
  @Emit()
  private all() {
    return;
  }
}
